import React from "react";
import { brands } from "../utils/constants";
import {Link } from 'react-router-dom'
import { LazyLoadImage } from "react-lazy-load-image-component";


const Brands = ({styles}) => {
  return (
    <section className={`bg-black lg:pb-6 -mt-[1px] px-8 md:px-16 ${styles}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        {brands.map((brand, i) => (
          <div key={i} className="space-y-2 text-white">

            <Link to={brand.link}>
            <LazyLoadImage
              className="w-full h-[350px] mb-5"
              style={{objectFit: 'cover'}}
                effect="blur"
              src={brand.img}
              alt={brand.title}
             
            />
            </Link>
          

            <div className="headings leading-[26px] text-[20px] lg:w-3/4">
              <div className="headings pb-5">
              <h1 className="font-bold">{brand.title}</h1>
              <h1  className="text-[16px] font-light">{brand.desc}</h1>
              </div>
            
              <Link className="border text-black hover:bg-slate-200 px-10 py-3 space-x-2 border-white bg-white" to={brand.link}>View Project</Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Brands;
